import * as React from "react";
import { __, __BETA } from "src/services/theme";

const HTML = (props) => (
    <section className="info">
    
      <header className="premium-nanny">
        <div className="container">
          <h1>Tata AD Words</h1>
          <p>
          Una scheda dettagliata e ricca di funzioni. <br />
          Informazioni aggiuntive e dettagliate convertono le visite in clienti potenziali
          con un incremento del <em> 95%</em> .<br />
          </p>
        </div>
      </header>
      
      <div className="hots">
        <div className="container">
            <ul className="icons">
              <li>
                <span><span><span className="icon-positive_dynamic_filled" /></span></span>
                <span><strong>Aumento visibilità</strong> della tua scuola</span>
              </li>
              <li>
                <span><span><span className="icon-callback" /></span></span>
                <span><strong>Aumento contatti</strong> telefonici/email</span>
              </li>
              <li>
                <span><span><span className="icon-coins" /></span></span>
                <span><strong>Open Day</strong> in homepage</span>
              </li>
            </ul>
        </div>
      </div>
      
      <div className="cta2 cta2-adwords">
        <div className="container">
            <article>
                <h2>Tata AD Words</h2>
                <p>
                    Il tuo profilo in evidenza nelle ricerche docenti nella tua zona. <br />
                    Inizia a guadagnare da subito. <br />
                </p>
                <div>
                    <button className="btn-block lg action wicon post" onClick={() => props.onClick()}><span>{ __BETA ? "COMING SOON" : "COMPRA" }<span className="icon-export"></span></span></button>
                    {!__BETA && <small>A partire da &euro;9,99/giorno</small>}
                </div>
            </article>
        </div>
      </div>
      
      <div className="faq container">
        <h2><span>Domande frequenti</span></h2>
        <div className="items">
          <article>
            <h4>{__('AcquistiTataAdWords.faq1_title')}</h4>
            <p>{__('AcquistiTataAdWords.faq1_text', 130)}</p>
          </article>
          <article>
            <h4>{__('AcquistiTataAdWords.faq2_title')}</h4>
            <p>{__('AcquistiTataAdWords.faq2_text', 130)}</p>
          </article>
        </div>
      </div>
      
    </section>
);

export default HTML;


// WEBPACK FOOTER //
// ./src/components/ecommerce/AcquistiTataInfo/Adwords.tsx